import { render, staticRenderFns } from "./Areas.vue?vue&type=template&id=15deba22&scoped=true"
import script from "./Areas.vue?vue&type=script&lang=js"
export * from "./Areas.vue?vue&type=script&lang=js"
import style0 from "./Areas.vue?vue&type=style&index=0&id=15deba22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15deba22",
  null
  
)

export default component.exports